<template lang="pug">
  div
    app-divider(label="Documentação", :tooltip="informacao")
    el-alert(
      v-if="pecasTecnicas && tipoSelecionado"
      :title="tipoSelecionado.descricao",
      type="info")
      br
      small {{mensagensTipoDocumento[tipoSelecionado.codigo].texto}}

    app-upload-documentos-anexar(
      :modulo="modulo",
      :valid-extensions="validExtensions",
      :max-size="maxSize",
      :scope="scope",
      :validateCampos="validateCampos",
      :validation-name="validationName",
      :validateDocumentos="validateDocumentos",
      :mutationAddDocumento="mutationAddDocumento",
      :getterTiposDocumentos="getterTiposDocumentos",
      :findTiposDocumento="findTiposDocumento",
      @tipoChanged="tipoSelecionado = $event"
    )
    el-row
      .input(:class="{'erro' : errors.has(getFieldName('Documentos')) }")
        el-table(
          :data='documentos',
          stripe
        )
          div(slot='empty')
            span Nenhum arquivo adicionado. Para adicionar um novo arquivo, clique no botão "Anexar" acima.
          el-table-column(
            prop='tipoDocumento.descricao',
            label='Tipo de documento'
            align="left",
          )
          el-table-column(
            prop='nome',
            label='Anexos'
          )
          el-table-column(
            label='Ações',
            align="center",
            width="80"
          )
            template(slot-scope='scope')
              app-action-button(
                icone="times",
                @click="deleteRow(scope.row)",
                cor="#CF0021",
                text="Remover documento"
              )
    p.help.erro(v-show="errors.has(getFieldName('Documentos'))")
      pre {{ errors.first(getFieldName('Documentos')) }}

</template>

<script>
import _ from 'lodash'
import AppActionButton from './AppActionButton'
import AppUploadDocumentosAnexar from './AppUploadDocumentosAnexar'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDivider from './AppDivider'
const { textoDocumentos } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  inject: ['$validator'],

  mixins: [
    AppNotificacao
  ],

  components: {
    AppActionButton,
    AppUploadDocumentosAnexar,
    AppDivider
  },

  data () {
    return {
      keyT: 0,
      tipoSelecionado: undefined,
      mensagensTipoDocumento: {
        ARQUIVOS_GRAFICOS: {
          texto: 'Os "Arquivos Gráficos" deverão ser compostos por shapes e planta (formato .dwg e uma cópia em .pdf).'
        },
        ARQUIVOS_LITERAIS: {
          texto: `Os "Arquivos Literais" deverão ser compostos por Relatórios de Processamento Base de Apoio,
                  Relatório de Processamento dos Vértices do Perímetro, Relatório Técnico, Planilha de Cálculo de Área Azimutes e Lados,
                  Memorial Descritivo (.doc e uma cópia em .pdf assinada), Tabela de Dados Cartográficos e outros arquivos que se fizerem necessários.`
        },
        ARQUIVOS_GNSS: {
          texto: `Os Arquivos GNSS deverão ser compostos por Dados Base (Dados Brutos e Dados Rinex),
                  Dados Rover (Dados Brutos e Dados Rinex), Obras de Processamento e Relatórios de Processamento (Base de Apoio e Vértices Perimétricos).`
        },
        OUTROS: {
          texto: textoDocumentos.OUTROS
        },
        ART_TRT: {
          texto: 'Anotação de Responsabilidade Técnica (ART) ou Termo de Responsabilidade Técnica (TRT) em formato PDF.'
        },
        TABELA_DADOS_CARTOGRAFICOS: {
          texto: 'Tabela de dados cartográficos em formato ods ou xls. A planilha deverá ser preenchida seguindo as instruções de preenchimento do manual do SIGEF (https://sigef.incra.gov.br/documentos/manual/#h.jguefngtcjoy). Além das recomendações de preenchimento do manual do SIGEF, o campo descritivo do confrontante da planilha também deverá sempre ser informado.'
        },
        DRD_DRL: {
          texto: `Declaração de Respeito de Divisas (DRD), informado pelo proprietário e responsável técnico que foi respeitado os limites e confrontações ou Declaração de Respeito de Limites (DRL) com a declaração de respeito pelo proprietário e confrontante (modelo disponível no endereço eletrônico oficial do ITERPA) em formato pdf.`
        },
        RELATORIO_DE_PROCESSAMENTO: {
          texto: `Relatório e dados de processamento para cada tipo de posicionamento utilizado para o georreferenciamento do imóvel (GNSS, topografia clássica, geometria analítica, sensoriamento remoto) de acordo com a legislação vigente. Em caso de Levantamento por posicionamento GNSS, no método Relativo, os dados devem ser compostos por observações GNSS da base de referência e do receptor móvel (RINEX e nativo), obra/projeto e relatórios do processamento. Em posicionamento pelo método RTK, deverá possuir relatório de processamento inalterado e os dados das observações GNSS da base de referência (RINEX e nativo). Já no posicionamento por ponto preciso, o relatório fornecido pelo IBGE, bem como as observações GNSS referentes aos dados coletados. Toda documentação deverá ser enviada em arquivo único em formato zip.`
        },
        RELATORIO_TECNICO_DE_EXECUCAO_DO_GEOPROCESSAMENTO: {
          texto: `Relatório Técnico de Execução do Georreferenciamento em formato PDF.`
        }
      }
    }
  },

  props: {
    scope: {
      type: String,
      required: true
    },
    validExtensions: {
      type: Array,
      required: true
    },
    maxSize: {
      type: Number,
      required: true
    },
    validateDocumentos: {
      type: Boolean,
      required: true
    },
    validationName: {
      type: String
    },
    validateCampos: {
      type: Object
    },
    modulo: {
      type: String,
      required: true
    },
    getterDocumentosSelecionados: {
      type: String,
      required: true
    },
    mutationAddDocumento: {
      type: String,
      required: true
    },
    mutationRemoveDocumento: {
      type: String,
      required: true
    },
    getterTiposDocumentos: {
      type: String,
      required: true
    },
    findTiposDocumento: {
      type: String,
      required: true
    },
    getterTiposDocumentosObrigatorios: {
      type: String,
      default: 'tiposDocumentosObrigatorios'
    },
    waitForRemoval: {
      type: Boolean,
      default: false
    },
    pecasTecnicas: {
      type: Boolean,
      default: false
    },
    isValidacaoPeloMenosUmDocumento: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    tiposDocumentosObrigatorios () {
      return this.$store.getters[`documentos/${this.getterTiposDocumentosObrigatorios}`]
    },

    documentos () {
      return this.$store.getters[`${this.modulo}/${this.getterDocumentosSelecionados}`].slice().sort(this.compare)
    },

    informacao () {
      if (this.isValidacaoPeloMenosUmDocumento) {
        return 'Para esta análise nenhum documento é obrigatório, mas é necessário anexar pelo menos um deles.'
      }

      if (this.tiposDocumentosObrigatorios && this.tiposDocumentosObrigatorios.length > 0) {
        const tiposObrigatorios = this.tiposDocumentosObrigatorios.map(tipoDocumentoObrigatorio => tipoDocumentoObrigatorio.descricao)

        let infoTipoDocumentosObrigatorios = 'Documentos obrigatórios:'

        tiposObrigatorios.forEach(documento => { // eslint-disable-line
          infoTipoDocumentosObrigatorios += '<br> - '
          infoTipoDocumentosObrigatorios += documento
        })

        return infoTipoDocumentosObrigatorios
      }
      return ''
    }
  },

  mounted () {
    if (this.validateDocumentos) {
      this.$validator.attach({
        name: 'Documentos',
        getter: () => this.validateCampos,
        rules: this.validationName,
        scope: this.scope
      })
    }
    if (process.env.ESTADO === 'ba') {
      this.mensagensTipoDocumento.DRD_DRL.texto =
        'Declaração de Respeito de Divisas (DRD), informado pelo proprietário e responsável técnico que foi respeitado os limites e confrontações ou Declaração de Respeito de Limites (DRL) com a declaração de respeito pelo proprietário e confrontante em formato pdf.'
    }
  },

  beforeDestroy () {
    if (this.validateDocumentos) {
      this.$validator.detach('Documentos', this.scope)
    }
  },

  methods: {
    getFieldName (fieldName) {
      return `${this.scope}.${fieldName}`
    },

    compare (a, b) {
      if (a.tipoDocumento.descricao.toLowerCase() < b.tipoDocumento.descricao.toLowerCase()) {
        return -1
      }
      if (a.tipoDocumento.descricao.toLowerCase() > b.tipoDocumento.descricao.toLowerCase()) {
        return 1
      }
      return 0
    },

    deleteRow (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          if (this.waitForRemoval) {
            this.$store.commit(`${this.modulo}/SET_REMOVABLE_SOCIO`, documento)
          } else {
            this.$store.commit(`${this.modulo}/${this.mutationRemoveDocumento}`, documento)
          }
        },
        () => {})
    }
  },

  watch: {
    documentos () {
      if (this.validateDocumentos) {
        const error = _.find(this.errors.items, error => error.field === 'Documentos')
        if (error) {
          this.$validator.validate(`${this.scope}.Documentos`)
        }
      }
    }
  }

}
</script>

<style scoped lang="scss">

  .table {
    width: 100%;
  }

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  .label-info{
    margin-bottom: 20px;
    span {
      font-size: 12px;
    }
  }

  .el-alert {
    color: #047fa2 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/AppUploadDocumentos.vue